import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IB2BService } from "../b2bserviceModel";

export const getAllB2BServices = createAsyncThunk(
  "B2BService/FindAllB2BService",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BService/FindAllB2BService`,
        {
          ServiceName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching B2B services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createB2BService = createAsyncThunk(
  "B2BService/InsertB2BService",
  async (B2BServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BService/InsertB2BService`,
        B2BServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating B2B service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateB2BService = createAsyncThunk(
  "B2BService/UpdateB2BService",
  async (B2BServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BService/UpdateB2BService`,
        B2BServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating B2B service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteB2BService = createAsyncThunk(
  "B2BService/DeleteB2BService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BService/DeleteB2BService`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting B2B service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getB2BServiceByID = createAsyncThunk(
  "B2BService/FindByIDB2BService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BService/FindByIDB2BService`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceName: result.ServiceName,
        IsActive: result.IsActive ? 1 : 2,
      } as IB2BService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching B2B service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveB2BServices = createAsyncThunk(
  "B2BService/FindAllActiveB2BService",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/B2BService/FindAllActiveB2BService`
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching active B2B services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const b2bServiceActiveInactive = createAsyncThunk(
  "B2BService/ActiveInActiveB2BService",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/B2BService/ActiveInActiveB2BService`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive B2B service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
